import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom';
import { getModuleList } from '../api/apiClient';
import { FullModule } from '../types';
import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import BackgroundWrapper from './BackgroundWrapper';
import ForegroundWrapper from './ForegroundWrapper';

const ModuleSelector = () => {
  const [modulesList, setModulesList] = useState<FullModule[]>([]);
  const [selectedModule, setSelectedModule] = useState<FullModule>({
    character: '',
    characterName: '',
    characterPersona: '',
    characterRole: '',
    communicationStyleA: '',
    communicationStyleB: '',
    communicationStyleC: '',
    conflictArea: '',
    environment: '',
    incitingIncident: '',
    keyMoments: [],
    learnerRole: '',
    learningObjective: '',
    location: '',
    moduleId: '',
    moduleName: '',
    moduleScript: undefined,
    scenario: '',
    summary: '',
    surveyQuestions: [],
    topic: '',
    voiceId: '',
  });

  const navigate = useNavigate();

  const fetchModuleList = async () => {
    await getModuleList()
      .then((data: FullModule[]) => {
        setModulesList(data);
      })
      .catch((err) => console.error('Failed to fetch module list:', err));
  };

  useEffect(() => {
    fetchModuleList();
  }, []);

  const handleSelectModule = (event: SelectChangeEvent) => {
    const currentModule: FullModule = event.target.value as any;
    setSelectedModule(currentModule);
    navigate(`/module/${currentModule.moduleId}`);
  };

  return (
    <BackgroundWrapper>
      <ForegroundWrapper>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <FormControl variant="standard" sx={{ m: 1, width: '100%' }}>
            <InputLabel id="demo-simple-select-standard-label">
              Select Module
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={selectedModule as any}
              onChange={handleSelectModule}
              label="Module"
            >
              {modulesList.map((module: FullModule) => (
                <MenuItem key={module.moduleId} value={module as any}>
                  {module.moduleName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </ForegroundWrapper>
    </BackgroundWrapper>
  );
};

export default ModuleSelector;
